export const WEEK_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;

export const EVENTS_STATUSES: { value: string | undefined; label: string }[] = [
  { value: undefined, label: "All" },
  { value: "EVENT_STATUS_PLANNED", label: "Upcoming" },
  { value: "EVENT_STATUS_STARTED", label: "Started" },
  { value: "EVENT_STATUS_IN_PROGRESS", label: "In Progress" },
  { value: "EVENT_STATUS_ENDED", label: "Ended" },
  { value: "EVENT_STATUS_CANCELLED", label: "Cancelled" },
];
